// import external dependencies

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import casinoGames from './routes/casinoGames';
import home from './routes/home';
import aboutUs from './routes/aboutUs';
import singlePost from './routes/singlePost';
import events from './routes/events';
import instantGames from './routes/instantGames';
import news from './routes/news';
import onlineGamingSuiteData from './routes/onlineGamingSuiteData';
import casinoJackpots from './routes/casinoJackpots';
import singularData from './routes/singularData';
import vlt from './routes/vlt';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Home page
  casinoGames,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singlePost,
  events,
  news,
  casinoJackpots,
  onlineGamingSuiteData,
  instantGames,
  singularData,
  vlt,
});
// Load Events
// if (document.readyState !== 'loading') {
document.addEventListener('DOMContentLoaded', function() {
  routes.loadEvents();
});

// }



// WEBPACK FOOTER //
// ./scripts/main.js